<template>
  <div id="loading-wrap">
    <div id="loading">
      <div style="text-align: center;">
        <img src="@/assets/images/html/loading.gif">正在加载中...
      </div>
    </div>
  </div>
</template>

<script scoped>
export default {
  name: "Loading",
  componentName: "Loading",
  data () {
    return {

    }
  },
  components: {

  },
  methods: {

  },
  computed: {

  }
}
</script>

<style scoped>
#loading-wrap {
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}

#loading {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
}

.spinner {
  width: 1em;
  height: 1em;
  border-radius: 50%;
  box-shadow: inset 0 0 0 0.1em rgba(58, 168, 237, 0.2);
  position: relative;
}

.spinner i {
  position: absolute;
  clip: rect(0, 1em, 1em, 0.5em);
  width: 1em;
  height: 1em;
  animation: spinner-circle-clipper 1s ease-in-out infinite;
  top: 0;
  left: 0;
}

.point {
  position: relative;
  width: 1em;
  height: 1em;
  display: flex;
  align-items: center;
}

.point i {
  height: 1em;
  line-height: 1em;
  position: absolute;
  overflow: hidden;
  animation: point 1.5s ease-in-out infinite;
}

@keyframes point {
  0% {
    width: 0;
  }

  100% {
    width: 100%;
  }
}

@keyframes spinner-circle-clipper {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(180deg);
  }
}

.spinner i::after {
  position: absolute;
  clip: rect(0, 1em, 1em, 0.5em);
  width: 1em;
  height: 1em;
  content: '';
  animation: spinner-circle 1s ease-in-out infinite;
  border-radius: 50%;
  box-shadow: inset 0 0 0 0.1em #3aa8ed;
  top: 0;
  left: 0;
}

@keyframes spinner-circle {
  0% {
    transform: rotate(-180deg);
  }

  100% {
    transform: rotate(180deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/scroll_load/loading.vue